<template>
  <b-container class="mt-2">
    <b-modal @show="Limpiar1" id="newDeliver">
      <template #modal-header> Repartidor Nuevo </template>

      <b-form-group label="Repartidor">
        <b-input autofocus v-model="nuevo.Nombre"></b-input>
      </b-form-group>

      <b-form-group label="Codigo">
        <b-input v-model="nuevo.Codigo"></b-input>
      </b-form-group>

      <template #modal-footer>
        <b-button variant="primary" @click="$bvModal.hide('newDeliver')">Cerrar</b-button>
        <b-button @click="Guardar" variant="success">Crear</b-button>
      </template>
    </b-modal>

    <b-row>
      <b-col> <h4>Repartidores</h4></b-col>
      <b-col class="gradiente text-center p-1"> </b-col>
    </b-row>
    <b-row>
      <b-table :items="Delivers" :fields="['Nombre', 'Codigo', 'Opcion']">
        <template #cell(Opcion)="data">
          <b-icon-trash-fill @click="Eliminar(data.item.id)" variant="danger" />
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col></b-col>
      <b-col cols="1">
        <b-button @click="$bvModal.show('newDeliver')" variant="success">Agregar</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { db } from "./db";

export default {
  computed: {
    Delivers() {
      let rs = this.Repartidores.map((item) => {
        return { id: item.id, Nombre: item.Nombre, Codigo: item.Codigo };
      });

      return rs;
    },
  },
  methods: {
    Eliminar(dato) {
      db.collection("Repartidor")
        .doc(dato)
        .delete();
    },
    Limpiar1() {
      this.nuevo = { Nombre: null, Codigo: null };
    },
    Guardar() {
      let n = { Nombre: this.nuevo.Nombre, Codigo: this.nuevo.Codigo };

      db.collection("Repartidor").add(n);
      this.$bvModal.hide("newDeliver");
    },
  },
  data() {
    return {
      newDeliver: false,
      nuevo: { Nombre: null, Codigo: null },
      Repartidores: [],
    };
  },
  firestore: {
    Repartidores: db.collection("Repartidor"),
  },
};
</script>
